export default {
    name: "lessonPlan",
    title: "Interactive Presentation",
    icon: require("./content-icon.svg"),
    category: "training"
}